// wxPay/WxPayRefundOrderEdit.tsx
import WxPayRefundOrderEditBase from './WxPayRefundOrderEditBase';

const WxPayRefundOrderEdit = (props: any) => (
    <WxPayRefundOrderEditBase apiId="wxPayRefundOrder" outerProps={props} />
);

export default WxPayRefundOrderEdit;